import React, { useRef } from 'react';
import History from './History';
import Directions from './Directions';

const Intro = () => {
  return (
    <>
      <div className="pages-main-wrap">
        <div className="intro-wrap" id="intro">
          <h1 className="intro-title">플레이션에 오신 것을 환영합니다!</h1>
        </div>

        <div className="intro-img-wrap">
          <div className="intro-img1"></div>
        </div>

        <div className="intro-grid">
          <div className="intro-section spirit" id="spirit">
            <h2>우리의 정신</h2>
            <ul>
              <li>플레이션(PLASSION)은 'PLAY'와 'PASSION'의 만남으로 탄생한 이름입니다.</li>
              <li>우리는 열정을 가지고 즐겁게 일하는 것이 최고의 결과를 만든다고 믿습니다.</li>
            </ul>
          </div>
          <div className="intro-section vision" id="vision">
            <h2>우리의 비전</h2>
            <ul>
              <li>작지만 강한 기업, 그것이 우리의 모토입니다.</li>
              <li>우리는 AI 기술을 적극 활용하여 시장에서 사랑받는 모바일 게임과 콘텐츠를 제작합니다.</li>
            </ul>
          </div>
          <div className="intro-section strengths" id="strengths">
            <h2>우리의 강점</h2>
            <ul>
              <li>· 혁신적 기술: 최신 AI 기술을 게임과 콘텐츠 개발에 접목시켜 효율성과 품질을 높입니다.</li>
              <li>· 열정적인 팀: 우리 팀원 모두가 자신의 일에 대한 열정과 즐거움을 가지고 있습니다.</li>
              <li>· 도전 정신: 작은 규모지만, 큰 꿈을 향해 끊임없이 도전합니다.</li>
              <li>· 긍정적 에너지: 어떤 어려움 앞에서도 긍정의 힘으로 극복해 나갑니다.</li>
            </ul>
          </div>
          <div className="intro-section what-we-do" id="what-we-do">
            <h2>우리가 하는 일</h2>
            <ul>
              <li>혁신적이고 재미있는 모바일 게임 개발</li>
              <li>사용자 중심의 매력적인 콘텐츠 제작</li>
              <li>AI 기술을 활용한 게임 및 콘텐츠 최적화</li>
            </ul>
          </div>
        </div>
        <div className="intro-victory">
          <h2>Ascend</h2>
          <span>플레이션</span>은 작지만 강한 기업으로 계속해서 성장해 나갈 것입니다.
          <br />
          우리의 열정적이고 도전적인 여정을 지켜봐 주세요.
          <br />
          혁신적인 게임과 콘텐츠로 디지털 세상에 새로운 가치를 만들어가는
          <span>
            <br />
            플레이션
          </span>
          의 모습을 기대해 주십시오!
        </div>
        <History />
      </div>
      <Directions />
    </>
  );
};

export default Intro;
